export default __webpack_public_path__ + "static/media/ic_edit.d2a1e90a.svg";